<template>
  <div class="overallStatisticsRootBox">
    <admin-layout v-if="userType===admin" style="padding-right: 16px;box-sizing: border-box"></admin-layout>
    <teacher-layout v-else-if="userType===teacher"></teacher-layout>
    <student-layout v-else-if="userType===student"></student-layout>
    <div v-else class="m-empty">未知人员类型（请刷新或者重新登陆）</div>
  </div>
</template>

<script>
import teacherLayout from './layout/teacherLayout.vue'
import AdminLayout from './layout/adminLayout.vue'
import StudentLayout from './layout/studentLayout.vue';

export default {
  name: "overallStatistics",
  provide() {
    return {
      getTime: this.getTime,
      secondsToDate: this.secondsToDate
    }
  },
  components: {
    StudentLayout,
    AdminLayout,
    teacherLayout
  },
  computed: {
    getTime() {
      return function (time) {
        const date = new Date(time)
        return date._$formatDateZh()
      }
    }
  },
  data() {
    return {
      userType: String(sessionStorage.getItem('userType')),
      admin: '0', //管理员
      teacher: '1', //老师
      student: '2', //学生
    }
  },
  created() {
  },
  methods: {
    secondsToDate(seconds = 0) {
      let ss = seconds % 60
      let mm = Math.floor(seconds / 60)
      let date = `${mm}分钟${ss}秒`
      if (mm >= 60) {
        mm = mm % 60
        let hh = Math.floor(seconds / 60 / 60)
        date = `${hh}小时${mm}分钟${ss}秒`
        if (hh >= 24) {
          hh = hh % 24
          let dd = Math.floor(seconds / 60 / 60 / 24)
          date = `${dd}天${hh}小时${mm}分钟${ss}秒`
        }
      }
      return date
    }
  }
}
</script>

<style lang="scss" scoped>
.overallStatisticsRootBox {
  --fontSize: calc(100vw / 19.2);
  padding-bottom: calc(0.12 * var(--fontSize));
  box-sizing: border-box;
  overflow-y: auto;
  height: calc(100vh - 64px);
  user-select: none;

  & > .m-empty {
    height: 100%;
    width: 100%;
    display: grid;
    place-items: center;
    font-weight: bold;
    background-color: white;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/overallStatistics.vue